export interface OrderByOption {
  type: string;
  title: string;
}
export enum GroupByOptions {
  Item = 'Item',
  Location = 'Location',
}
